export default "__VITE_ASSET__BGXMtzzD__"